import { render, staticRenderFns } from "./error_404.vue?vue&type=template&id=4afedb92&scoped=true&"
var script = {}
import style0 from "./error_404.vue?vue&type=style&index=0&id=4afedb92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afedb92",
  null
  
)

export default component.exports